
import { defineComponent } from "vue";

import "@/styles/tailwind.css";
import "./styles/fonts.css";

export default defineComponent({
  name: "App",
});
